import { Box, ListItemButton, ListItemText, ListItem } from "@material-ui/core";
import "./BMXSelectList.scss";
import { List } from "react-window";
import PropTypes from "prop-types";
import { get } from "lodash";

function renderRow(props) {
  const { index, style, onClick, onClose } = props;
  return (
    <ListItem
      className="BMXListItem"
      style={{
        ...style,
        borderBottom: "1px solid #e0e0e0",
      }}
      key={index}
      component="div"
      disablePadding
    >
      <ListItemButton
        onClick={() => {
          onClick(get(props, `data[${index}]`, null));
          onClose();
        }}
      >
        <ListItemText
          style={{ margin: "0 2rem 0 0", textWrap: "nowrap" }}
          primary={get(props, `data[${index}]primary`, "-")}
          secondary={get(props, `data[${index}]secondary`, null)}
        />
      </ListItemButton>
    </ListItem>
  );
}

const BMXSelectList = (props) => {
  const { data, onClick, onClose } = props;
  const primaryLength = Number(
    get(
      data?.toSorted((a, b) => b?.primary?.length - a?.primary?.length),
      "[0].primary",
    )?.length || 0,
  );
  const secondaryLength = Number(
    get(
      data?.toSorted((a, b) => b?.secondary?.length - a?.secondary?.length),
      "[0].secondary",
    )?.length || 0,
  );
  const rowWidth = Number(
    primaryLength > secondaryLength ? primaryLength : secondaryLength,
  );

  return (
    <Box
      className="BMXSelectList"
      sx={{
        height: "max-content",
        width: "max-content",
        bgcolor: "background.paper",
      }}
    >
      <List
        rowHeight={52}
        rowCount={data?.length}
        style={{
          maxHeight: 400,
          width: `${rowWidth + 5}ch`,
        }}
        rowProps={{ data: data, onClick: onClick, onClose: onClose }}
        overscanCount={10}
        rowComponent={renderRow}
      />
    </Box>
  );
};

BMXSelectList.requiredProps = {
  data: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  onClose: PropTypes.func,
};

BMXSelectList.defaultProps = {
  data: [],
  onClick: (val) => console.log("click:", val),
  onClose: () => {},
};

export default BMXSelectList;
